const LateralMenu = {
  parts: ['menu', 'logo'],
  baseStyle: {
    menu: {
      display: { base: 'none', md: 'flex' },
      flexDir: 'column',
      bgColor: 'gray.900',
    },
    brand: {
      height: '1.5rem',
      width: '10rem',
      padding: '0 1rem',
      h: '5rem',
      display: { base: 'none', sm: 'block' },
      w: { base: '0', sm: '14rem' },
    },
  },
};

export default LateralMenu;
